export const INVITE_SUCCESS = "INVITE_SUCCESS";
export const INVITE_ACCEPT = "INVITE_ACCEPT";
export const INVITE_REJECT = "INVITE_REJECT";
export const INVITE_MAYBE = "INVITE_MAYBE";
export const INVITE_EDIT = "INVITE_EDIT";
